import React from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import {Modal, Button} from 'react-bootstrap';


const ErrorLogin = ({handlePasswordDimenticata, handleClose, showModal}) =>{

    return (
        <>
            <Modal show={showModal} onHide={handleClose} backdrop='static' keyboard="False" size="lg" centered>
                <Modal.Header className={'justify-content-end py-0'}>
                    <Button variant={'link'} onClick={handleClose}>
                        chiudi x
                    </Button>
                </Modal.Header>
                <Modal.Body className={'mt-4 mb-5'}>
                    <h2 className={'title fw-bold'}>Dati utenti errati</h2>
                    <Button variant={'link'} onClick={(e) => handlePasswordDimenticata(e)} className={'px-0'}>Password dimenticata</Button>
                    <p>Riprova accesso...</p>
                </Modal.Body>
                <Modal.Footer className={'pt-0'}>
                    <Button variant={'primary'} className={'px-3'} onClick={handleClose}>
                        Riprova accesso
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default ErrorLogin;